/**
 * Empty-state placeholder shown when a list/table has no data. Optionally
 * renders an icon and a call-to-action (e.g. a "Create" button).
 */
import type { ReactElement, ReactNode } from 'react';

export interface EmptyStateProps {
  title?: string;
  message?: string;
  icon?: ReactNode;
  action?: ReactNode;
  className?: string;
}

/** Centered empty-state block. */
export default function EmptyState({
  title = 'Chưa có dữ liệu',
  message,
  icon,
  action,
  className = '',
}: EmptyStateProps): ReactElement {
  return (
    <div
      className={`flex flex-col items-center justify-center gap-3 px-4 py-12 text-center ${className}`.trim()}
    >
      {icon && <div className="text-gray-400" aria-hidden="true">{icon}</div>}
      <h3 className="text-sm font-semibold text-gray-900">{title}</h3>
      {message && <p className="max-w-sm text-sm text-gray-500">{message}</p>}
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}
